import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-chatbot-kit/build/main.css";
import "./App.css";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./Utils/AuthProvider";
import { DataProvider } from "./Utils/DataProvider";
import "react-image-lightbox/style.css";
import "../src/styles/css/bootstrap.min.css";
import "../src/styles/css/animate.min.css";
import "../src/styles/css/boxicons.min.css";
import "../src/styles/css/flaticon.css";
import "swiper/css";
import "swiper/css/bundle";
import "../src/styles/css/style.css";
import "../src/styles/css/responsive.css";
import { RecoilRoot } from "recoil";

import Loader from "./components/Loader";
import useDelayedLoader from "./Utils/DelayedLoader";
import ScrollToTop from "./Utils/ScrollToTop";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { initializeMatomo } from "./Utils/Matomo";

const App = lazy(() => import("./App"));

const theme = {
  colors: {
    white: "#FFFFFF",
    lightBlack: "#161616",
    primary: "#0159C3",
    primaryOpacity25: "#185ab833",
    secondary: "#004FD5",
    grey: "#313a46",
    lightGrey: "#8391A2",
    tableBG: "#FAFBFE",
    sidebar: "#4D55CC",
    background: "#FAFBFE",
  },
  shadows: {
    boxShadow: "0px 0px 35px 0px rgba(77, 85, 204, 0.15)",
  },
};

const DelayedLoaderFallback = () => {
  const showLoader = useDelayedLoader(300);
  return showLoader ? (
    <div className="loader">
      <Loader loading={true} size={50} />
    </div>
  ) : null;
};

// Initialize Matomo Analytics
initializeMatomo();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <RecoilRoot>
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <DataProvider>
          <BrowserRouter>
            <ScrollToTop />

            <Suspense fallback={<DelayedLoaderFallback />}>
              <App />
            </Suspense>
            <ToastContainer />
          </BrowserRouter>
        </DataProvider>
      </ThemeProvider>
    </AuthProvider>
  </RecoilRoot>
);

reportWebVitals();
